import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from 'tradera-lang';
import { formatDuration } from 'tradera-utils/format';
import { useTicker } from '../hooks';

const AnimatedTimeLeftLabel = ({
    className,
    countdownSecondsLimit,
    countdownWarningLimit,
    tagName: TagName,
    endDate,
    timeLeft
}) => {
    const { t } = useTranslator();
    const timeLeftSeconds = useMemo(
        () => Math.floor((new Date(endDate) - new Date()) / 1000),
        [endDate]
    );
    const [countdown, setCountdown] = useState(timeLeftSeconds);
    const stopCountdown = useTicker(1000, () => {
        if (countdown > 0) {
            setCountdown(countdown - 1);
        } else {
            stopCountdown();
        }
    });
    if (isNaN(countdown)) {
        return null;
    }
    return (
        <TagName className={`item-card-animate-time ${className}`}>
            {countdown <= 0 ? (
                <span className={`text-danger`}>{t('itemCard_ended')}</span>
            ) : (
                <span
                    className={`${
                        countdown <= countdownWarningLimit ? 'text-danger' : ''
                    }`}>
                    {formatDuration(countdown, countdownSecondsLimit) || (
                        // eslint-disable-next-line
                        <span dangerouslySetInnerHTML={{ __html: timeLeft }} />
                    )}
                </span>
            )}
        </TagName>
    );
};
AnimatedTimeLeftLabel.propTypes = {
    className: PropTypes.string,
    countdownSecondsLimit: PropTypes.number,
    countdownWarningLimit: PropTypes.number,
    tagName: PropTypes.string,
    endDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    timeLeft: PropTypes.string
};
AnimatedTimeLeftLabel.defaultProps = {
    className: '',
    // Show detailed countdown at this number of seconds left
    countdownSecondsLimit: 120,
    // Show warning countdown at this number of seconds
    countdownWarningLimit: 60,
    tagName: 'span'
};

export default AnimatedTimeLeftLabel;
